import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-1 2a1 1 0 1 0 0 2v8a1 1 0 1 0 2 0v-9a1 1 0 0 0-1-1h-1Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }